import React, {useState, useEffect} from "react";

const withTemplateGridMultiSelectCheckbox = (WrappedComponent) => (props) => {
    const [selectedValues, setSelectedValues] = useState(
        props.value.map((item) => item.toString()) || [],
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const colId = props?.column?.colId;
        props.node.setDataValue(colId, selectedValues);
    }, [selectedValues, props?.column?.colId, props?.node]);

    const toggleCheckbox = (opt) => {
        if (["ALL", "DEFAULT"].includes(opt?.name)) {
            setSelectedValues([opt?.name]);
            return;
        }
        const isOptSelected = selectedValues?.some(
            (selected) => selected === opt?.name,
        );

        let newValues = isOptSelected
            ? selectedValues.filter((selected) => selected !== opt?.name)
            : [...selectedValues, opt?.name];

        newValues = newValues.filter(
            (item) => !["ALL", "DEFAULT"].includes(item),
        );

        if (newValues?.length === 0 && props.isRequired) {
            alert("At least one element must be selected!");
            return;
        }
        setSelectedValues(newValues);
    };

    const handleClose = () => {
        const colId = props?.column?.colId;
        const rowNode = props.api.getRowNode(props.node.id);
        if (rowNode) {
            const updatedData = {...rowNode.data, [colId]: selectedValues};
            rowNode.setData({...rowNode.data, [colId]: selectedValues});
        }
        props.api.stopEditing(true);
    };

    useEffect(() => {
        setAnchorEl(props.eGridCell);
    }, [props.eGridCell]);

    const isOptionChecked = (option) =>
        selectedValues?.some((selected) => selected === option?.name);

    const injectedProps = {
        toggleCheckbox,
        anchorEl,
        handleClose,
        isOptionChecked,
    };

    return <WrappedComponent {...props} {...injectedProps} />;
};

export default withTemplateGridMultiSelectCheckbox;
